import React from "react";
import { reviewAggregationToolBarId } from "./ReviewAggregationToolbarV2";
import { CustomerReviews, FilteredBy } from "./reviewModels";
import ReviewsStarBreakdownContent from "./ReviewsStarBreakdownContent";
interface ReviewStarBreakdownProps {
  reviews: CustomerReviews;
  isProductReviewPage?: boolean;
  filteredBy?: FilteredBy;
  onRatingClick: (rating: number) => void;
}
export interface RatingCounts {
  reviewCount: number;
  rating: number;
}
const ReviewsStarBreakdownV2 = ({
  reviews,
  isProductReviewPage,
  filteredBy,
  onRatingClick
}: ReviewStarBreakdownProps) => {
  const ratingClickHandler = (rating: number) => {
    onRatingClick(rating);
  };
  const ratingCounts = (() => {
    const counts: RatingCounts[] = [];
    for (let starRating = 5; starRating > 0; starRating -= 1) {
      counts.push({
        rating: starRating,
        reviewCount: reviews.productReviewDetails.filter(review => review.oneToFiveStarRating === starRating).length
      });
    }
    return counts;
  })();
  const filteredByRating = filteredBy?.rating ? parseInt(filteredBy.rating, 10) : undefined;
  return <div className={`review-star-breakdown ${isProductReviewPage ? "w-1/2 border-t-0 lt:flex lt:justify-center lt:items-center lt:py-6 lt:border-r pl-3.5 pr-4 xs:pl-[18px] xs:pr-5 lt:pl-6" : "xxxl:border-r pl-[18px] pr-[18px] sm:pr-2 xxxl:pl-[26px] xxxl:pr-4"} py-0 border-gray-200 xs:border-0 xs:border-l xs:border-solid ${!reviews.summary ? "xxxl:w-1/3" : "xxxl:w-[30%]"}`} data-sentry-component="ReviewsStarBreakdownV2" data-sentry-source-file="ReviewsStarBreakdownV2.tsx">
      <div className={`${isProductReviewPage ? "py-3" : "py-5 xxxl:py-0"} w-full flex flex-col`}>
        <ul className="list-none p-0 m-0 flex flex-col">
          {ratingCounts.map(ratingCount => <li key={ratingCount.rating} className={``}>
              <a className={`flex items-center group hover:no-underline py-[3px] pl-1 pr-0.5 border-2 border-solid rounded focus:outline-blue-700 ${filteredByRating && filteredByRating === ratingCount.rating ? "font-bold border-green-500" : "underline border-transparent"}`} href={`#${reviewAggregationToolBarId}`} onClick={() => ratingClickHandler(ratingCount.rating)} data-testid={`review-rating-${ratingCount.rating}`}>
                <ReviewsStarBreakdownContent ratingCount={ratingCount} filteredByRating={filteredByRating} reviews={reviews} />
              </a>
            </li>)}
        </ul>
      </div>
    </div>;
};
export default ReviewsStarBreakdownV2;